import script from "./QuarkEditDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./QuarkEditDialog.vue?vue&type=script&setup=true&lang=js"

import "./QuarkEditDialog.vue?vue&type=style&index=0&id=774a8d3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-774a8d3e"]])

export default __exports__